import React, { useContext, useEffect, useState } from "react";
import { ContextProvider } from "../../App";
import { domainUrl } from "../utils/constant";
import { toast } from "react-toastify";
import { useParams } from "react-router";

const useGetReviews = () => {
  const { id } = useParams();
  const [reviewsData, setReviewsData] = useState([]);
  const { token } = useContext(ContextProvider);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    if (!token) {
      // toast.info("You have to login first");
      return;
    } else {
      try {
        const response = await fetch(`${domainUrl}/getAllReviewers/:` + id);

        // console.log(response);

        if (response.status !== 200) {
          throw new Error("API Internal error");
        } else {
          const json = await response.json();
          setReviewsData(json);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  return { reviewsData };
};

export default useGetReviews;
